module.exports = __webpack_public_path__ + "static/ya-fe58c591618cb87686520c7f929e8afa.png";